module.exports = __webpack_public_path__ + "img/icon_page1_line2.485b08ff.png";